import { useParams, useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import { useState, useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Box, Button, CircularProgress, Stack, Typography, Card, CardContent, Divider, DialogContent, Dialog } from '@mui/material';
import Iconify from '../../reuseable-components/iconify/Iconify';
import axiosInstance from '../../utils/axios';
import OrderList from '../Order/OrderList';
import InvoiceList from '../Invoice/InvoiceList';

export default function FacilityInfo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [facility, setFacility] = useState({});
  const [loading, setLoading] = useState(false);
  const [showOrders, setShowOrders] = useState(false);
  const [showInvoices, setShowInvoices] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(`/facility/Facility?id=${id}`)
      .then((res) => setFacility(res.data))
      .catch(() => enqueueSnackbar('Fetch facility data failed', { variant: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} sx={{ left: '50%',
        transform: 'translateX(-50%)', textAlign: 'center', overflow: 'hidden' }}>
        {facility?.name}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 4, mt:4,  width: '100%', position: 'relative' }}>   
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => navigate('/admin/orderSheet', { state: { facilityId: id,}, })} >
            New Order
          </Button>
          <Button variant="outlined" startIcon={<Iconify icon="mdi:clipboard-list-outline" />}
            onClick={() => { navigate('/admin/orders', { state: { facilityId: id, facilityName: facility?.name }, })}} >
            Orders
          </Button>
          <Button variant="outlined" startIcon={<Iconify icon="mdi:file-document-outline" />}
            onClick={() => { navigate('/admin/invoices', { state: { facilityId: id, facilityName: facility?.name }, })}}>
            Invoices
          </Button>
        </Stack>
      {loading && (<Stack alignItems="center" justifyContent="center" sx={{ mt: 10 }}><CircularProgress /></Stack>)}
      {!loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
          <Card sx={{ width: 600 }}>
            <CardContent>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}> Facility Details </Typography>
              <Divider sx={{ mb: 2 }} />
              <Stack spacing={1.5}>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary"> Name </Typography>
                  <Typography variant="body1">{facility.name}</Typography>
                </Box>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary"> Address </Typography>
                  <Typography variant="body1"> {facility?.billingAddress
                    ? `${facility.billingAddress.streetAddress || ''} ${facility.billingAddress.city || ''}, ${facility.billingAddress.state || ''} ${facility.billingAddress.zip || ''}`
                    : '- - - - - -'} </Typography>
                </Box>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary"> Contact</Typography>
                  <Typography variant="body1" component="div">
                    {facility?.contacts?.length
                      ? facility.contacts.map((c, i) => {
                        const fullName = [c.firstName, c.lastName].filter(Boolean).join(" ");
                        return (
                          <Box key={i}>
                            {[fullName, c.cell, c.email].filter(Boolean).join(" | ")}
                          </Box>
                        );
                      })
                      : "- - - - - -"}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>

  );
}
